<template>
  <div
    ref="dialog"
    class="mdc-dialog"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="my-dialog-title"
    aria-describedby="my-dialog-content"
    @keyup.enter="onClickOnSubmit()"
  >
    <div class="mdc-dialog__container">
      <div class="mdc-dialog__surface">
        <h2 v-if="!isForgotPassword" class="mdc-dialog__title">Log in</h2>
        <h2 v-if="isForgotPassword" class="mdc-dialog__title">Recover your password</h2>

        <div class="mdc-dialog__content" id="my-dialog-content">
          <p
            v-if="errored"
            class="text-error"
          >There was an error. Check your email and password are valid or try again later</p>
          <p
            v-if="passwordResetEmailSuccess"
            class="text-success"
          >A reset password email has been sent</p>
          <p
            v-if="passwordResetEmailError"
            class="text-error"
          >Couldn't send reset password email. Ensure the email exists or try again later</p>
          <Input v-model="email" label="Email"></Input>
          <div class="separator"></div>
          <Input v-if="!isForgotPassword" v-model="password" label="Password" type="password"></Input>
          <div class="separator"></div>
          <a v-if="!isForgotPassword" @click="onClickOnForgotPassword()">Forgot your password?</a>
        </div>
        <footer class="mdc-dialog__actions">
          <button
            type="button"
            class="mdc-button mdc-dialog__button"
            data-mdc-dialog-action="close"
          >
            <span class="mdc-button__label">Cancel</span>
          </button>
          <button
            v-if="!isForgotPassword"
            @click="onClickOnSubmit()"
            type="button"
            class="mdc-button mdc-button--raised mdc-dialog__button"
            :disabled="loading"
          >
            <span class="mdc-button__label">Log in</span>
          </button>
          <button
            v-if="isForgotPassword"
            @click="onClickOnSendRecoveryEmail()"
            type="button"
            class="mdc-button mdc-button--raised mdc-dialog__button"
            :disabled="loading"
          >
            <span class="mdc-button__label">Recover</span>
          </button>
        </footer>
      </div>
    </div>
    <div class="mdc-dialog__scrim"></div>
  </div>
</template>

<script>
import { MDCDialog } from "@material/dialog";
import Input from "./Input.vue";

export default {
  props: ["visible"],
  mounted() {
    this.dialog = new MDCDialog(this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", () => {
      this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data() {
    return {
      errored: false,
      dialog: null,
      email: "",
      password: "",
      loading: false,
      isForgotPassword: false,
      passwordResetEmailSuccess: false,
      passwordResetEmailError: false
    };
  },
  methods: {
    onClickOnSubmit() {
      this.loading = true;
      this.$firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .catch(error => {
          this.errored = true;
        })
        .then(response => {
          this.loading = false;
          if (response && response.user) {
            this.errored = false;
            this.$emit("onLogedIn", response.user);
          }
        });
    },
    onClickOnSendRecoveryEmail() {
      this.$firebase.auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          this.passwordResetEmailError = false;
          this.passwordResetEmailSuccess = true;
        })
        .catch((error) => {
          this.passwordResetEmailSuccess = false;
          this.passwordResetEmailError = true;
        });
    },
    onClickOnForgotPassword() {
      this.isForgotPassword = true;
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.errored = false;
        this.isForgotPassword = false;
        this.passwordResetEmailSuccess = false;
        this.passwordResetEmailError = false;
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input
  }
};
</script>

<style lang="scss" scoped>
.mdc-dialog__surface {
  min-width: 320px;
  max-width: 320px;
}
.separator {
  height: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/LoginDialog.vue